<template>
<v-container>
	<v-flex d-flex justify-center>
		<CommentForm />
	</v-flex>
	<v-layout v-for="comment in comments" class="card">
		<v-flex md1 class="wrap-logo">
			<div class="logo">
				<img src="../../../../assets/temp_user_logo.png" alt="" width="50px" height="50px">
				<span>{{comment.user_name}}</span>
				<span class="data">{{comment.created_at}}</span>
			</div>
		</v-flex>
		<v-flex md9 offset-md1 class="content">
			{{comment.text}}
		</v-flex>
		<v-flex md9 class="content">
			<ConfirmDialog @accept="deleteWithNotify(comment.id)" v-bind="propConfirmDialog">
				<v-icon dark>delete</v-icon>
			</ConfirmDialog>
		</v-flex>
	</v-layout>
</v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CommentForm from './CommentForm'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import { notify } from '../../../../utils/notifications'

export default {
	data: vm => ({
		propConfirmDialog: {
			message: vm.$t('common.confirm_message_comment'),
			title: vm.$t('workers.comment'),
			btnProps: {
				color: 'red lighten-2',
				flat: true,
				fab: true
			}
		}
	}),
	components: {
		CommentForm,
		ConfirmDialog
	},
	computed: {
		...mapState({
			comments: ({ workers }) => workers.comments
		})
	},
	methods: {
		...mapActions({
			deleteComment: 'workers/deleteComment'
		}),
		deleteWithNotify(id) {
			this.deleteComment(id).then(() => {
				this.$notify({
				...notify,
					text: this.$t('notifications.deleted', {
						type: this.$t('common.comment')
					})
				})
			})
		}
	}
}
</script>

<style scoped>
.logo {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.card {
	margin-top: 10px;
}
.content {
	display: flex;
	justify-content: center;
	flex-direction: column;
	font-size: 16px;
	padding-left: 10px;
	align-items: flex-start;
}
.wrap-logo {
	max-width: 150px;
	min-width: 150px;
	border-right: 1px solid #dedede;
}
.data {
	font-size: 12px;
}
</style>
